import type { Doc } from "building-types/doc";
import type { OptionHandle } from "building-types/handles/docEntityHandleTypes";
import type { DocOption, ElevationOptionSet } from "building-types/options/optionSet";
import { assertIsNotNullOrUndefined } from "common/utils/assertOfType";
import { getElevationOptionSet } from "../elevation";

export function docGetElevationOptionSet(doc: Pick<Doc, "optionSets">): ElevationOptionSet | undefined {
  return getElevationOptionSet(doc.optionSets);
}

export function docGetElevationOptionSetOrThrow(doc: Pick<Doc, "optionSets">): ElevationOptionSet {
  const optionSet = docGetElevationOptionSet(doc);
  assertIsNotNullOrUndefined(optionSet, "Elevation option set not found");
  return optionSet;
}

export function docGetOption(doc: Pick<Doc, "optionSets">, item: OptionHandle): DocOption {
  return doc.optionSets[item.optionSetId]?.options?.[item.optionKey];
}
